module.exports = __webpack_public_path__ + "static/BGTSM-7d0be5aa0abb9fbf52b3c4d28c47c024.webp";